<template>
  <div class="doc-upload">
  
    <div class="page-header">
          <div class="row justify-content-end">
            <div class="col-10 text-left">
              <h2 class="page-title">{{$t('registration.tabs.tabDocumentUpload')}}</h2>
            </div>
            <div class="col-2 lighten text-right">
              <h2 class="page-title">68%</h2>
            </div>
          </div>
        </div>
    <div class="row justify-content-center">
<!-- Profile Photo-->
    <div class="col-3" v-if="profilesrc">

      <div  class="title">{{$t('candidateProfile.documentUpload.lblProfilePhoto')}}</div>
      <img :src="profilesrc" class="ppic documentImg img-fluid img-thumbnail" >
    </div>
    <div :class="profilesrc || showDocuments ? 'col-9' : 'col-12'">
      <div class="title">{{$t('candidateProfile.documentUpload.lblProfilePhoto')}}</div>
      <vue-dropzone ref="myVueDropzone"  @vdropzone-file-added="fileAdded('Profile',$event)" @vdropzone-removed-file="fileRemoved" id="dropzone1" :options="dropzoneOptions"></vue-dropzone>
      <small class="text-info">Document size should be less than 1MB</small>
    </div>
    <!-- HSC MarkSheet-->
    <div class="col-3" v-if="sscsrc">
      <div class="title">{{$t('candidateProfile.documentUpload.lblSscDoc')}}</div>
      <img :src="sscsrc" class="dpic documentImg img-fluid img-thumbnail"  @click="showSSCModal = true">
    </div>
    <div :class="sscsrc  ? 'col-9' : 'col-12'">
      <div class="title">{{$t('candidateProfile.documentUpload.lblSscDoc')}}</div>
      <vue-dropzone ref="myVueDropzone"   @vdropzone-file-added="fileAdded('SSC',$event)" @vdropzone-removed-file="fileRemoved" id="dropzone2" :options="dropzoneOptions"></vue-dropzone>
    <small class="text-info">Document size should be less than 1MB</small>
    </div>
    <!-- HSC MarkSheet-->
    <div class="col-3" v-if="hscsrc && showHSC">
          <div class="title">{{$t('candidateProfile.documentUpload.lblHscDoc')}}</div>
          <img :src="hscsrc" class="dpic documentImg img-fluid img-thumbnail" @click="showHSCModal = true"> 
    </div>    
        <div :class="hscsrc  ? 'col-9' : 'col-12'" v-if="showHSC">
          <div class="title">{{$t('candidateProfile.documentUpload.lblHscDoc')}}</div>
          <vue-dropzone ref="myVueDropzone" id="dropzone3"   @vdropzone-file-added="fileAdded('HSC',$event)" @vdropzone-removed-file="fileRemoved" :options="dropzoneOptions"></vue-dropzone>
           <small class="text-info">Document size should be less than 1MB</small>        
        </div>
<!-- Diploma MarkSheet-->
    <div class="col-3" v-if="diplomasrc && showDiploma">
        <div class="title">{{$t('candidateProfile.documentUpload.lblDiplomaDoc')}}</div>
       <img :src="diplomasrc" class="dpic documentImg img-fluid img-thumbnail" @click="showDiplomaModal = true">
    </div>
     <div :class="diplomasrc ? 'col-9' : 'col-12'" v-if="showDiploma">
      <div class="title">{{$t('candidateProfile.documentUpload.lblDiplomaDoc')}}</div>
      <vue-dropzone ref="myVueDropzone" id="dropzone4"  @vdropzone-file-added="fileAdded('Diploma',$event)" @vdropzone-removed-file="fileRemoved" :options="dropzoneOptions"></vue-dropzone>
    <small class="text-info">Document size should be less than 1MB</small>
    </div>
<!-- Diploma HAll Ticket-->
    <div class="col-3" v-if="diplomaHallTicketsrc && showDiplomaHallTicket">
        <div class="title">{{$t('candidateProfile.educationDetails.lblDiplomaTicketDoc')}}</div>
        <img :src="diplomaHallTicketsrc" class="dpic documentImg img-fluid img-thumbnail" >
    </div>
     <div :class="diplomaHallTicketsrc ? 'col-9' : 'col-12'" v-if="showDiplomaHallTicket">
      <div class="title">{{$t('candidateProfile.educationDetails.lblDiplomaTicketDoc')}}</div>
      <vue-dropzone ref="myVueDropzone" id="dropzone4"  @vdropzone-file-added="fileAdded('DiplomaHallTicket',$event)" @vdropzone-removed-file="fileRemoved" :options="dropzoneOptions"></vue-dropzone>
    <small class="text-info">Document size should be less than 1MB</small>
    </div>
<!-- HSC HAll Ticket-->
    <div class="col-3" v-if="hscHallTicketsrc && showHSCHallTicket">
        <div class="title">{{$t('candidateProfile.educationDetails.lblHSCHallTicketDoc')}}</div>
        <img :src="hscHallTicketsrc" class="dpic documentImg img-fluid img-thumbnail">
    </div>
     <div :class="hscHallTicketsrc ? 'col-9' : 'col-12'" v-if="showHSCHallTicket">
      <div class="title">{{$t('candidateProfile.educationDetails.lblHSCHallTicketDoc')}}</div>
      <vue-dropzone ref="myVueDropzone" id="dropzone4"  @vdropzone-file-added="fileAdded('HSCHallTicket',$event)" @vdropzone-removed-file="fileRemoved" :options="dropzoneOptions"></vue-dropzone>
    <small class="text-info">Document size should be less than 1MB</small>
    </div>

    </div>
    <div class=" row text-center p-3">
        <button type="button" class="btn btn btn-info-alt mr-3" @click="prevTabFunc"> {{$t('button.back')}}</button>
        <button type="button" class="btn btn btn-orange ml-auto" @click="nextTabFunc"> {{$t('button.next')}}</button>
    </div>
    <!-- loader -->
    <div class="loader-wraper" v-show="loading===true">
      <div class="loader-box">
      <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
      <h6 class="mt-2">Please wait...</h6>
      </div>
    </div>
    <!--//-->
    <!--Modal-->
    <modal class="lg" v-if="showSSCModal" @close="showSSCModal = false">   
          <h3 slot="header">SSC Document</h3>
          <div slot="body">
           <img :src="sscsrc"  width="100%">
           </div>
       
    </modal>
      <modal class="lg" v-if="showHSCModal" @close="showHSCModal = false">   
          <h3 slot="header">HSC Document</h3>
          <div slot="body">
           <img :src="hscsrc" width="100%">
           </div>
           
    </modal>
    <modal class="lg" v-if="showDiplomaModal" @close="showDiplomaModal = false">   
          <h3 slot="header">DIploma Document</h3>
          <div slot="body">
           <img :src="diplomasrc"  width="100%">
           </div>
    </modal>
     
    <!--EOF Modal-->
    </div> 
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.css'
import modal from '@/components/common/modal.vue'
import axios from 'axios'
// import lodash from 'lodash'
var tus = require('tus-js-client')
export default {
  components: {vueDropzone: vue2Dropzone, modal},
  data () {
    return {
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 350,
        previewsContainer: false,
        maxFilesize: 1,
        maxFiles: 1,
        headers: { 'My-Awesome-Header': 'header value' },
        addRemoveLinks: true,
        uploadMultiple: false,
        acceptedFiles: 'image/*'
      },
      selectedFile: null,
      /* CDN_BUSINESS_HEADER: this.CDN_BUSINESS_HEADER,
      CDN_CLIENT_HEADER: this.CDN_CDN_CLIENT_HEADER, */
      documentdata: {
        filepath: '',
        thumbnailpath: ''
      },
      data: false,
      files: [],
      details: {},
      showHSC: false,
      showDiploma: false,
      showDiplomaHallTicket: false,
      showHSCHallTicket: false,
      filename: '',
      filepath: '',
      path: '',
      checkpath: '',
      cdnid: 'CDN_001',
      cdnid1: '',
      dbCheckFileResponse: '',
      // currentYear: (new Date()).getFullYear(),
      currentYear: '',
      fileUploadStatus: {
        'SSC': false,
        'HSCorDiploma': false,
        'HSCorDiplomaHallTicket': false,
        'profilePic': false
      },
      profilesrc: '',
      sscsrc: '',
      hscsrc: '',
      diplomasrc: '',
      diplomaHallTicketsrc: '',
      hscHallTicketsrc: '',
      showDocuments: false,
      processedName: '',
      processedPath: '',
      modalDiplomasrc: '',
      loading: false,
      fileCheckResponse: {},
      deleteFileResponse: {},
      showSSCModal: false,
      showHSCModal: false,
      showDiplomaModal: false
    }
  },
  methods: {
    nextTabFunc () {
      this.documentStatus()
    },
    prevTabFunc () {
      this.$router.push('educationalDetails')
    },
    UploadFile (name, path) {
      let uploadForm = this
      uploadForm.filepath = uploadForm.currentYear + '/documents/' + path
      uploadForm.checkpath = uploadForm.currentYear + '/documents/' + path
      for (var i = 0; i < uploadForm.files.length; i++) {
        uploadForm.selectedFile = uploadForm.files[i]
        let fileExtension = uploadForm.selectedFile.name.split('.').pop()
        fileExtension = '.' + fileExtension
        uploadForm.filename = new Date().getTime() + name + fileExtension
        // var filePathFromDB
        uploadForm.uploadFileOnCDN(name)
        /* uploadForm.checkFileInDB(name, uploadForm.filename).then(function (filePathDB) {
          filePathFromDB = filePathDB
          uploadForm.CheckFileOnCDN(filePathFromDB, name).then(function () {
            uploadForm.DeleteFileFromCDN(filePathFromDB).then(function () {
              uploadForm.uploadFileOnCDN(name)
            }).catch(function (error) {
              console.error('Error in DeleteFileFromCDN : ' + error)
            })
          }).catch(function (error) {
            console.error('Error in CheckFileOnCDN : ' + error)
          })
        }).catch(function (error) {
          console.error('Error in checkFileInDB : ' + error)
        }) */
      }
    },
    uploadFileOnCDN (name) {
      let uploadForm = this
      let upload = new tus.Upload(uploadForm.selectedFile, {
        endpoint: uploadForm.CDN_LOAD_BALANCER_URL + '?res-o',
        chunkSize: 500000,
        metadata: {
          filename: uploadForm.filename
        },
        headers: {
          'Bussiness-Code': uploadForm.CDN_BUSINESS_HEADER,
          'Client-Code': uploadForm.CDN_CLIENT_HEADER,
          'Path': uploadForm.filepath
        },
        retryDelays: [0, 1000, 3000, 5000],
        onError: function (error) {
          uploadForm.$toasted.error(uploadForm.$t('candidateProfile.documentUpload.toastrFileAlreadyExists'), {
            duration: '2000', theme: 'bubble'
          })
          console.error(error)
        },
        onSuccess: function () {
          if (upload._xhr.response !== '') {
            uploadForm.path = upload._xhr.response
            uploadForm.uploadData(name)
            return
          } else {
            uploadForm.$toasted.error(uploadForm.$t('candidateProfile.documentUpload.toastrNoResponse'), {
              duration: '2000', theme: 'bubble'
            })
            return
          }
        }
      })
    // Start the upload
      upload.start()
      uploadForm.reset()
    },
    fileprocessing (fileid) {
      // this.loading = false
      let fileprocess = this
      let profileName = fileprocess.$store.state.candidateProfile.profileUser
      let processedName = ''
      let processedPath = ''
      if (fileid === 'Profile') {
        processedName = profileName + '_ProfilePicture'
        processedPath = 'profilepicture/' + profileName
        fileprocess.UploadFile(processedName, processedPath)
      }
      if (fileid === 'SSC') {
        processedName = profileName + '_SSC'
        processedPath = 'Results/' + profileName
        fileprocess.UploadFile(processedName, processedPath)
      }
      if (fileid === 'HSC') {
        processedName = profileName + '_HSC'
        processedPath = 'Results/' + profileName
        fileprocess.UploadFile(processedName, processedPath)
      }
      if (fileid === 'Diploma') {
        processedName = profileName + '_Diploma'
        processedPath = 'Results/Diploma/' + profileName
        fileprocess.UploadFile(processedName, processedPath)
      }
      if (fileid === 'DiplomaHallTicket') {
        processedName = profileName + '_DiplomaHallTicket'
        processedPath = 'Results/DiplomaHallTicket/' + profileName
        fileprocess.UploadFile(processedName, processedPath)
      }
      if (fileid === 'HSCHallTicket') {
        processedName = profileName + '_HSCHallTicket'
        processedPath = 'Results/HSCHallTicket/' + profileName
        fileprocess.UploadFile(processedName, processedPath)
      }
    },
    fileAdded (doc, file) {
      if (file.size / 1024 <= 1024) {
        this.files.push(file)
        this.loading = true
        this.fileprocessing(doc)
      } else {
        this.loading = false
        this.$toasted.error(this.$t('candidateProfile.documentUpload.toastrDocumentsUploadSizeError'))
      }
    },
    uploadData (id) {
      let uploaddata = this
      let profileName = uploaddata.$store.state.candidateProfile.profileUser
      axios
      .post('r/upload/' + profileName, { 'docId': id, 'docName': uploaddata.filename, 'docImage': uploaddata.path })
      .then(function (response) {
        uploaddata.data = response.data
        var pfName = ''
        var pfNameArray = profileName.split('.')
        for (let item = 0; item < pfNameArray.length; item++) {
          pfName = pfName + pfNameArray[item]
        }
        var fileName = uploaddata.filename.split('.')
        var nameOfDoc = ''
        /* var printName = 'Documents' */
        for (let item = 0; item < fileName.length - 1; item++) {
          nameOfDoc = nameOfDoc + fileName[item]
        }
        if (uploaddata.data === true) {
          if (nameOfDoc === pfName + '_SSC') {
            uploaddata.fileUploadStatus.SSC = true
          /*   uploaddata.$toasted.success('Documents' + uploaddata.$t('candidateProfile.documentUpload.toastrDocumentsUploadSuccess'), {
              duration: uploaddata.TOASTR_TIME, theme: 'bubble'
            }) */
          }
          if (nameOfDoc === pfName + '_HSC' || nameOfDoc === pfName + '_Diploma') {
            uploaddata.fileUploadStatus.HSCorDiploma = true
            /* uploaddata.$toasted.success('Documents' + uploaddata.$t('candidateProfile.documentUpload.toastrDocumentsUploadSuccess'), {
              duration: uploaddata.TOASTR_TIME, theme: 'bubble'
            }) */
          }
          if (nameOfDoc === pfName + '_HSCHallTicket' || nameOfDoc === pfName + '_DiplomaHallTicket') {
            uploaddata.fileUploadStatus.HSCorDiplomaHallTicket = true
          }
          if (nameOfDoc === pfName + '_ProfilePicture') {
            uploaddata.fileUploadStatus.profilePic = true
            /* uploaddata.$toasted.success('Profile photo' + uploaddata.$t('candidateProfile.documentUpload.toastrDocumentsUploadSuccess'), {
              duration: uploaddata.TOASTR_TIME, theme: 'bubble'
            }) */
          }
          uploaddata.$toasted.success('Document' + uploaddata.$t('candidateProfile.documentUpload.toastrDocumentsUploadSuccess'), {
            duration: uploaddata.TOASTR_TIME, theme: 'bubble'
          })
          uploaddata.getEducationalDetails()
          uploaddata.loading = false
          window.localStorage.clear()
        }
      }).catch(function () {
        uploaddata.loading = false
      })
    },
    reset () {
      this.files = []
    },
    CheckFileOnCDN (checkfilepath, name) {
      var checkfile = this
      return new Promise(function (resolve, reject) {
        axios.post(checkfile.CDN_URL + 'o/isfilepresent', { 'url': checkfilepath }, { headers: {'Bussiness-Code': checkfile.CDN_BUSINESS_HEADER, 'Client-Code': checkfile.CDN_CLIENT_HEADER} })
        .then(Response => {
          checkfile.fileCheckResponse = Response.data
          if (Response.status === 200) {
            if (checkfile.fileCheckResponse.filePresentFlag === true) {
              resolve()
            } else {
              checkfile.uploadFileOnCDN(name)
            }
          }
        }).catch(function () {
          reject()
        })
      })
    },
    DeleteFileFromCDN (deletepath) {
      var deletefile = this
      return new Promise(function (resolve, reject) {
        axios.post(deletefile.CDN_URL + 'o/deletefile', { 'url': deletepath }, { headers: {'Bussiness-Code': deletefile.CDN_BUSINESS_HEADER, 'Client-Code': deletefile.CDN_CLIENT_HEADER} })
        .then(Response => {
          deletefile.deleteFileResponse = Response.data
          if (Response.status === 200) {
            if (deletefile.deleteFileResponse.fileDeleted === true) {
              resolve()
            } else {
              deletefile.$toasted.error(deletefile.$t('candidateProfile.documentUpload.toastrNoResponse'), {
                duration: deletefile.TOASTR_TIME, theme: 'bubble'
              })
            }
          }
          // return
        }).catch(function () {
          reject()
        })
      })
    },
    getEducationalDetails () {
      let sample = this
      var userName = this.$store.state.candidateProfile.profileUser
      axios
      .post('r/fetchDetails', {userName: userName})
      .then(function (response) {
        sample.details = response.data
        for (let item = 0; item < sample.details.documents.length; item++) {
          if (sample.details.documents[item].docId === userName + '_ProfilePicture') {
            sample.fileUploadStatus.profilePic = true
          }
          if (sample.details.documents[item].docId === userName + '_SSC') {
            sample.fileUploadStatus.SSC = true
          }
          if (sample.details.documents[item].docId === userName + '_HSC') {
            sample.fileUploadStatus.HSCorDiploma = true
          }
          if (sample.details.documents[item].docId === userName + '_HSCHallTicket') {
            sample.fileUploadStatus.HSCorDiplomaHallTicket = true
          }
          if (sample.details.documents[item].docId === userName + '_Diploma') {
            sample.fileUploadStatus.HSCorDiploma = true
          }
          if (sample.details.documents[item].docId === userName + '_DiplomaHallTicket') {
            sample.fileUploadStatus.HSCorDiplomaHallTicket = true
          }
        }
        sample.showHSC = sample.details.educationDetails.isHSCPassed
        sample.showDiploma = sample.details.educationDetails.isDiplomaPassed
        sample.showHSCHallTicket = sample.details.educationDetails.isHSCAppeared
        sample.showDiplomaHallTicket = sample.details.educationDetails.isDiplomaAppeared
        sample.getDocuments()
      })
    },
    fileRemoved (file, error, xhr) {
      for (let i = 0; i < this.files.length; i++) {
        if (this.files[i].upload.uuid === file.upload.uuid) {
          this.files.splice(i, 1)
          break
        }
      }
    },
    checkFileInDB (docid, name) {
      let db = this
      return new Promise(function (resolve, reject) {
        let userName = db.$store.state.candidateProfile.profileUser
        axios.post('r/checkfile/' + userName, { 'docId': docid })
        .then(Response => {
          if (Response.status === 200) {
            db.dbCheckFileResponse = Response.data
            if (db.dbCheckFileResponse === '') {
              db.uploadFileOnCDN(docid)
            } else {
              resolve(db.dbCheckFileResponse)
            }
          }
        })
        .catch(e => {
          reject(e)
            // db.$toasted.info(db.$t('candidateProfile.documentUpload.toastrDataNotPresent'), {
            //   duration: 1000, theme: 'bubble'
            // })
        })
      })
    },
    documentStatus () {
      var status = this
      if ((status.fileUploadStatus.SSC === true && status.fileUploadStatus.profilePic === true) && (status.fileUploadStatus.HSCorDiplomaHallTicket === true || status.fileUploadStatus.HSCorDiploma === true)) {
       /*  status.$toasted.success(status.$t('candidateProfile.documentUpload.toastrDocumentsUploadedSuccess'), {
          duration: status.TOASTR_TIME, theme: 'bubble'
        }) */
        var userName = this.$store.state.candidateProfile.profileUser
        axios.post('r/savedocumentstatus/' + userName)
        .then(function (response) {
          if (response.status === 200) {
            axios.get('r/projectConfig/getAllProjectConfig')
            .then(responses => {
              status.$toasted.success(status.$t('candidateProfile.documentUpload.toastrDocumentsUploadedSuccess'))
              if (responses.data.ocrConfig.required) {
                status.$router.push({ name: 'imageExtracter' })
              } else {
                status.$router.push({ name: 'qualificationDetails' })
              }
            })
            .catch(e => {
              console.log(e)
            })
          }
        })
        .catch(e => {
          status.$toasted.info(status.$t('candidateProfile.documentUpload.toastrFailToUpdateStatus'), {
            duration: status.TOASTR_TIME,
            theme: 'bubble'
          })
        })
      } else {
        status.$toasted.error(status.$t('candidateProfile.documentUpload.toastrDocumentsUploadError'), {
          duration: status.TOASTR_TIME, theme: 'bubble'
        })
      }
    },
    getDocuments () {
      var doc = this
      var profileUser = doc.$store.state.candidateProfile.profileUser
      if (doc.details.documents.length === 0) {
        doc.showDocuments = false
      } else {
        doc.showDocuments = true
        let myarray = doc.details.documents
        myarray.forEach(element => {
          if (element.docId === (profileUser + '_ProfilePicture')) {
            doc.profilesrc = element.docImage
            doc.$store.commit('STORE_PROFILE_USER_PHOTO', doc.profilesrc)
          } else if (element.docId === (profileUser + '_SSC')) {
            doc.sscsrc = element.docImage
          } else if (element.docId === (profileUser + '_HSC')) {
            doc.hscsrc = element.docImage
          } else if (element.docId === (profileUser + '_DiplomaHallTicket')) {
            doc.diplomaHallTicketsrc = element.docImage
            doc.modalDiplomasrc = element.docImage
          } else if (element.docId === (profileUser + '_HSCHallTicket')) {
            doc.hscHallTicketsrc = element.docImage
            doc.modalDiplomasrc = element.docImage
          } else if (element.docId === (profileUser + '_Diploma')) {
            doc.diplomasrc = element.docImage
            doc.modalDiplomasrc = element.docImage
          } else {
          }
        })
      }
    },
    getAcademicYear () {
      axios.get('o/projectConfig/getCurrentAcademicYear')
      .then(response => {
        if (response.data) {
          this.currentYear = response.data
        }
      })
      .catch(e => {
        console.log(e)
      })
    },
    callLoader () {
      this.loader = true
    }
  },
  created: function () {
    if (this.$store.state.user.userDetails.confirmStatus) {
      this.$router.push({ name: 'entry' })
    } else {
      this.getEducationalDetails()
      this.getAcademicYear()
    }
  }
}
</script>

<style lang='scss'>
.ppic{border-radius:5px; display: block; width:150px; height:150px; margin-top:10px;}
.dpic{border-radius:5px; display: block; width:150px; height:150px; margin-top:10px;}
.dpic{
    transition: all .2s ease-in;
    cursor: pointer;
  }
  .dpic:hover{
    transform: scale(1.1);
    border: 2px solid #ccc;
  }
.doc-upload{
  .title{
    // font-size:1px;
    margin-top:30px;
        font-weight: 500;
    // font-size: 18px;
    // color: #78838e;
    display: block;

  }
  .vue-dropzone{
    border:2px dashed #bbb;
    margin-top:10px;
    font-family: 'Open Sans';
    // font-size:13px;
    padding-top:25px;
    margin-bottom:0px;
    background-color:#f7f7f7;
    border-radius:5px;
    // padding-right:50px;
     .dz-preview .dz-details {
      bottom: 0;
      margin-right:30px;
      top: 0;
      color: #555;
      // background-color: #fff;
      background-color:#fff;
      transition: opacity .2s linear;
      text-align: left;
      border-radius:4px;
        
    }
    .dz-remove {
          position: absolute;
          z-index: 30;
          color: white;
          background-color: #aaa;
          margin-left: 15px;
          padding: 10px 20px;
          top: inherit;
          bottom: 15px;
          border-radius:20px;
          border: none;
          text-decoration: none;
          text-transform: uppercase;
          font-size: 12px;
          font-family: 'Open Sans';
          font-weight: 600;
          letter-spacing:0.4px;
          opacity: 0;
          &:hover{text-decoration: none; background-color:#999;}
      }
    &:hover{background-color:#eee;}
  }
}
.loader-wraper{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 101;
  background: rgba(255,255,255,0.7);
  animation: fadeIn  0.5s ease-in-out;
  .loader-box{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color:  #607D8B;

  }
  .lds-roller {
  display: block;
  position: relative;
  width: 64px;
  height: 64px;
  margin: 0 auto;
}
.lds-roller div {
  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 32px 32px;
}
.lds-roller div:after {
  content: " ";
  display: block;
  position: absolute;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #607D8B;
  margin: -3px 0 0 -3px;  
}
.lds-roller div:nth-child(1) {
  animation-delay: -0.036s;
}
.lds-roller div:nth-child(1):after {
  top: 50px;
  left: 50px;
}
.lds-roller div:nth-child(2) {
  animation-delay: -0.072s;
}
.lds-roller div:nth-child(2):after {
  top: 54px;
  left: 45px;
}
.lds-roller div:nth-child(3) {
  animation-delay: -0.108s;
}
.lds-roller div:nth-child(3):after {
  top: 57px;
  left: 39px;
}
.lds-roller div:nth-child(4) {
  animation-delay: -0.144s;
}
.lds-roller div:nth-child(4):after {
  top: 58px;
  left: 32px;
}
.lds-roller div:nth-child(5) {
  animation-delay: -0.18s;
}
.lds-roller div:nth-child(5):after {
  top: 57px;
  left: 25px;
}
.lds-roller div:nth-child(6) {
  animation-delay: -0.216s;
}
.lds-roller div:nth-child(6):after {
  top: 54px;
  left: 19px;
}
.lds-roller div:nth-child(7) {
  animation-delay: -0.252s;
}
.lds-roller div:nth-child(7):after {
  top: 50px;
  left: 14px;
}
.lds-roller div:nth-child(8) {
  animation-delay: -0.288s;
}
.lds-roller div:nth-child(8):after {
  top: 45px;
  left: 10px;
}
@keyframes lds-roller {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

}

@keyframes fadeIn {
    from {opacity: 0;}
    to {opacity: 1;;}
}
</style>



// WEBPACK FOOTER //
// src/components/registration/documentsupload.vue